export const errorsKeys = {
  //components errors
  statusErrors:['operation_success','operation_cancel','operation_not_found', 'attempts_are_over'],
  signOperation_success: {
    type: 'signOperation_success',
    message: '¡Hola! Tu operación ya fue realizada correctamente',
    button: 'close'
  },
  signOperation_cancel: {
    type: 'signOperation_cancel',
    message: '¡Hola! La operación ya no se encuentra disponible',
    help_message: 'Comunicarse con Mesa de Ayuda',
    button: 'close'
  },
  signOperation_not_found: {
    type: 'signOperation_not_found',
    message: 'La operación no está disponible',
    button: 'close'
  },
  attempts_are_over: {
    type: 'attempts_are_over',
    message: '¡Hola! Tu operación ya no tiene intentos disponibles',
    help_message: 'Comunicarse con Mesa de Ayuda',
    button: 'close'
  }
};

